import { render, staticRenderFns } from "./Zongjian.vue?vue&type=template&id=0f360d78&scoped=true"
import script from "./Zongjian.vue?vue&type=script&lang=js"
export * from "./Zongjian.vue?vue&type=script&lang=js"
import style0 from "./Zongjian.vue?vue&type=style&index=0&id=0f360d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f360d78",
  null
  
)

export default component.exports